import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import GenerateReportData from '../layout/GenerateReportData';

const PieChats = ({ data }) => {
  const [selectedCategory, setSelectedCategory] = useState(Object.keys(data)[0]);
  const baseurlReportList = `${process.env.REACT_APP_SERVER_URL}/aipd/userReportListByUserGroupId?userGroupId=${selectedCategory === "Admin" ? 101 : selectedCategory === "Headquarter" ? 103 :selectedCategory === "Field" ? 102 :selectedCategory === "Dealer" ? 104  :101}`;
  const [ReportData, setReportData] = useState();
  const [isLoading,setIsloading] =useState(false)

  const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];
  const handleChange = (event) => {
    setSelectedCategory(event.target.value);
    setIsloading(true)
  };


  const GetUserReportList = async () => {
    try {
      const response = await fetch(baseurlReportList, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        // console.log(jsonData);
        setReportData(jsonData)
        setIsloading(false)
      } else {
        
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  useEffect(()=>{
    GetUserReportList()
  },[selectedCategory,isLoading])

  const selectedChartData = data[selectedCategory].chats[0];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <select value={selectedCategory} onChange={handleChange}>
          {Object.keys(data)
            .filter((category) => category !== "MGS Labs Global Old")
            .map((category) => (
              <option key={category} value={category}>
                {data[category].name}
              </option>
            ))}
        </select>

        <div>
          {isLoading && (
            <>
              <button
                style={{
                  fontSize: "14px",
                  padding: "12px",
                  border: "none",
                  width: "50px",
                  borderRadius: "6px",
                }}
                title="Export in excel"
              >
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>
            </>
          )}
          {!isLoading && (
            <>
              <GenerateReportData
                excelData={ReportData}
                fileName={`${selectedCategory}_Report_${new Date().getTime()}`}
              />
            </>
          )}
        </div>
      </div>

      <ReactApexChart
        options={{
          chart: {
            type: "donut",
          },
          colors: [
            "#008FFB",
            "#00E396",
            "#FEB019",
            "#669DB5",
            "#94A74A",
            "#93C3EE",
            "#E5C6A0",
          ],
          fill: {
            type: "gradient",
          },
          labels: selectedChartData.XAxis,
          legend: {
            position: "bottom",
          },
        }}
        series={selectedChartData.YAxis}
        type="donut"
        height="330"
      />
    </div>
  );
};

export default PieChats;
